import { ProductionComponentInstance } from '@paragon/contract-library';
import { distanceEquals } from '@paragon/geometry-library';

export function sortProductionComponentInstances(
  instanceOne: ProductionComponentInstance,
  instanceTwo: ProductionComponentInstance,
) {
  const { bundlePositionX: instanceOneBundlePositionX, bundlePositionY: instanceOneBundlePositionY } = instanceOne;
  const { bundlePositionX: instanceTwoBundlePositionX, bundlePositionY: instanceTwoBundlePositionY } = instanceTwo;
  if (
    instanceOneBundlePositionX === null ||
    instanceOneBundlePositionY === null ||
    instanceTwoBundlePositionX === null ||
    instanceTwoBundlePositionY === null
  )
    throw new Error('Bundle position not set for bundled instance');

  // Order by y, x, analysisSetGuid, instanceGuid
  if (distanceEquals(instanceOneBundlePositionY, instanceTwoBundlePositionY)) {
    if (distanceEquals(instanceOneBundlePositionX, instanceTwoBundlePositionX)) {
      if (instanceOne.analysisSetGuid === instanceTwo.analysisSetGuid) {
        return instanceOne.guid > instanceTwo.guid ? 1 : -1;
      }

      return instanceOne.analysisSetGuid > instanceTwo.analysisSetGuid ? 1 : -1;
    }

    return instanceOneBundlePositionX > instanceTwoBundlePositionX ? 1 : -1;
  }

  return instanceOneBundlePositionY > instanceTwoBundlePositionY ? 1 : -1;
}
